"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTZHours = exports.formatJSCDate = exports.getWeekNumber = exports.getFirstDayOfWeek = void 0;
function getFirstDayOfWeek(d) {
    d = new Date(d); // DO not remove this as the mobile app is not in type script
    var day = d.getDay(), diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}
exports.getFirstDayOfWeek = getFirstDayOfWeek;
function getWeekNumber(b) {
    var d = new Date(Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())); // DO not remove this as the mobile app is not in type script
    var firstDayOfYear = new Date(Date.UTC(b.getFullYear(), 0, 1));
    var pastDaysOfYear = (d.getTime() - firstDayOfYear.getTime()) / 86400000;
    var value = Math.ceil(pastDaysOfYear / 7);
    return value;
}
exports.getWeekNumber = getWeekNumber;
function formatJSCDate(day, month, year) {
    var date = new Date();
    date.setFullYear(parseInt(year));
    date.setMonth(parseInt(month) - 1); //0 based index month
    date.setDate(parseInt(day));
    return date;
}
exports.formatJSCDate = formatJSCDate;
/**
 * Convert a date to a specific time zone and returns corresponding hour
 * @param date Date to convert  in string format
 * @param tzString The timezone string. ex: Europe/Paris
 * @returns
 */
function convertTZHours(date, tzString) {
    var a = new Date(new Date(date).toLocaleString('en-US', { timeZone: tzString }));
    return a.getHours();
}
exports.convertTZHours = convertTZHours;
